import {
  SET_JOB_CONFIGS,
  GET_PRODUCT_BACKGROUNDS,
  GET_PRODUCT_OVERLAYS,
  GET_PRODUCT_KNOCKOUT_PAIRS
} from 'app/actions/types';

import {
  getJobConfigs as getJobConfigsSvc,
  getProductBackgrounds as getProductBackgroundsSvc,
  createProductBackground as createProductBackgroundsSvc,
  getProductAssetSignedUrl as getProductAssetSignedUrlSvc,
  getProductOverlays as getProductOverlaysSvc,
  createProductOverlays as createProductOverlaysSvc,
  getProductKnockoutPairs as getProductKnockoutPairsSvc,
  createProductKnockOutPair as createProductKnockoutPairSvc,
  updateProductKnockoutPair as updateProductKnockoutPairSvc,
  deleteProductKnockoutPair as deleteProductKnockoutPairSvc,
  deleteProductBackground as deleteProductBackgroundSvc,
  deleteProductOverlay as deleteProductOverlaySvc,
  createDiscountCode as createDiscountCodeSvc,
  deleteBackgroundAspect as deleteBackgroundAspectSvc,
  deleteOverlayAspect as deleteOverlayAspectSvc
} from 'app/services/jobConfigs';

import {
  uploadFile as uploadFileSvc
} from 'shared/services/FileService';

export const getJobConfigs = params => async dispatch => {
  let jobConfigs = await getJobConfigsSvc(params);

  if (jobConfigs) {
    dispatch({
      type: SET_JOB_CONFIGS,
      payload: jobConfigs.params
    });
  }

  return jobConfigs;
}

export const setJobConfigParams = params => async dispatch => {
  dispatch({
    type: SET_JOB_CONFIGS,
    payload: params
  });
}

export const getProductBackgrounds = (accountId, productId) => async dispatch => {
  let backgrounds = await getProductBackgroundsSvc(accountId, productId)

  if (backgrounds) {
    dispatch({
      type: GET_PRODUCT_BACKGROUNDS,
      payload: backgrounds
    });
  }

  return backgrounds;
}

export const createProductBackground = (accountId, productId, backgrounds, backgroundId) => async dispatch => {
  const params = {
    account_id: accountId,
    product_id: productId,
    id: backgroundId,
    backgrounds
  }
  return await createProductBackgroundsSvc(accountId, params);
}

export const uploadProductAsset = (bgMomentId, type, file) => async dispatch => {
  var signed = await getProductAssetSignedUrlSvc(bgMomentId, type, true);
  return await uploadFileSvc(signed.url, file)
}

export const getProductOverlays = (accountId, productId) => async dispatch => {
  let overlays = await getProductOverlaysSvc(accountId, productId)

  if (overlays) {
    dispatch({
      type: GET_PRODUCT_OVERLAYS,
      payload: overlays
    });
  }

  return overlays;
}

export const createProductOverlays = (productId, overlays, overlayId) => async dispatch => {
  const params = {
    product_id: productId,
    id: overlayId,
    overlays
  }
  return await createProductOverlaysSvc(productId, params);
}

export const getKnockOutProductPairs = (accountId, productId) => async dispatch => {
  let pairs = await getProductKnockoutPairsSvc(accountId, productId)

  if (pairs) {
    dispatch({
      type: GET_PRODUCT_KNOCKOUT_PAIRS,
      payload: pairs
    });
  }

  return pairs;
}

export const createProductKnockOutPair = (accountId, productId, params) => async dispatch => {
  return await createProductKnockoutPairSvc(accountId, productId, params);
}

export const updateProductKnockoutPair = (accountId, productId, knockOutId, params) => async dispatch => {
  return await updateProductKnockoutPairSvc(accountId, productId, knockOutId, params);
}

export const deleteProductKnockoutPair = (accountId, productId, knockOutId) => async dispatch => {
  return await deleteProductKnockoutPairSvc(accountId, productId, knockOutId);
}

export const deleteProductBackground = (accountId, productId, backgroundId) => async dispatch => {
  return await deleteProductBackgroundSvc(accountId, productId, backgroundId);
}

export const deleteProductOverlay = (productId, overlayId) => async dispatch => {
  return await deleteProductOverlaySvc(productId, overlayId);
}

export const deleteBackgroundAspect = (accountId, backgroundId, aspectId) => async dispatch => {
  return await deleteBackgroundAspectSvc(accountId, backgroundId, aspectId);
}

export const deleteOverlayAspect = (productId, overlayId, aspectId) => async dispatch => {
  return await deleteOverlayAspectSvc(productId, overlayId, aspectId);
}

